// removed by extract-text-webpack-plugin
module.exports = {"noSearch":"_3ew5M","highlight":"_3bQtz","result":"JucO0","link":"_35sU5","warning":"_3sT3j"};


//////////////////
// WEBPACK FOOTER
// ./components/AutocompleteResult/styles.scss
// module id = 599
// module chunks = 0